import { render, staticRenderFns } from "./NameHeart.vue?vue&type=template&id=0780309c&scoped=true&"
import script from "./NameHeart.vue?vue&type=script&lang=js&"
export * from "./NameHeart.vue?vue&type=script&lang=js&"
import style0 from "./NameHeart.vue?vue&type=style&index=0&id=0780309c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0780309c",
  null
  
)

export default component.exports